import { render, staticRenderFns } from "./slogan.vue?vue&type=template&id=e8a6652e&scoped=true"
import script from "./slogan.vue?vue&type=script&lang=js"
export * from "./slogan.vue?vue&type=script&lang=js"
import style0 from "./slogan.vue?vue&type=style&index=0&id=e8a6652e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a6652e",
  null
  
)

export default component.exports